<template>
  <div :class="$style.tableContainer">
    <div :class="$style.tableHeader">
      <span :class="$style.tableHeaderTitle">{{ tableTitle }}</span>
      <RenewDeleteDropDown
        :disabled="isDropDownDisabled"
        :itemType="itemType"
        :tokenId="selectedToken"
        @renewVppToken="$emit('renewVppToken', $event)"
      />
    </div>
    <TableWithCustomColumns
      :class="$style.table"
      :columns="columns"
      :itemType="itemType"
      :renderActionColumn="true"
      :tableData="tableData"
    />
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { extend, values } from 'lodash';
import { mapState } from 'vuex';
import RenewDeleteDropDown from 'client/MDM/RenewDeleteDropDown.vue';
import TableWithCustomColumns from 'client/components/Tables/TableWithCustomColumns.vue';

export default {
  name: 'VppConfigurationTable',

  components: {
    RenewDeleteDropDown,
    TableWithCustomColumns,
  },

  props: {
    columns: {
      type: Array,
      default() { return []; },
    },
    itemType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return values(ItemTypeConsts).indexOf(value) !== -1;
      },
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableTitle: {
      default: '',
      type: String,
    },
  },

  computed: {
    isDropDownDisabled() {
      return this.selectedToken === '';
    },
  },

  beforeCreate() {
    const { itemType } = this.$options.propsData;
    const storeModule = StoreModuleMap[itemType];

    extend(
      this.$options.computed,
      mapState(storeModule, ['selectedToken']),
    );
  },
};
</script>

<style module>
  .tableContainer > .table {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .tableHeader {
    align-items: center;
    background-color: white;
    border: 1px solid #d7e3e6;
    border-bottom: none;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    font-size: 14px;
    font-weight: bold;
    justify-content: space-between;
    padding: 10px;
  }

  .tableHeader .tableHeaderTitle {
    padding-left: 20px;
  }
</style>
